module.exports = __webpack_public_path__ + "static/media/game-bg.fc8b4019.png";